import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "col-lg-4 col-md-6 col-sm-12"
}
const _hoisted_3 = {
  key: 1,
  class: "col-lg-4 col-md-6 col-sm-12"
}
const _hoisted_4 = {
  key: 2,
  class: "col-lg-2 col-sm-12 col-12 d-flex d-lg-block justify-content-center"
}

import SelectVue from '@/components/SelectVue.vue';
import {toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  props: {
  filters: {
    type: Object,
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
},
  emits: ['search'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Use toRefs to maintain reactivity
const {filters} = toRefs(props);
const clientDropdown = toRefs(props)['clientDropdown'];
const officeDropdown = toRefs(props)['officeDropdown'];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(onSearch, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(clientDropdown) && _unref(clientDropdown).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(SelectVue, {
              modelValue: _unref(filters).clientId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).clientId) = $event)),
              options: _unref(clientDropdown),
              "is-clear": true,
              placeholder: _ctx.$t('placeholder.client_name')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (_unref(officeDropdown) && _unref(officeDropdown).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(SelectVue, {
              modelValue: _unref(filters).officeId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).officeId) = $event)),
              options: _unref(officeDropdown),
              "is-clear": true,
              placeholder: _ctx.$t('placeholder.office_name')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (
           _unref(clientDropdown) && _unref(clientDropdown).length ||
           _unref(officeDropdown) && _unref(officeDropdown).length
         )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(SearchButton, {
              type: "submit",
              label: _ctx.$t('general.button.search'),
              loading: __props.loading
            }, null, 8, ["label", "loading"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}
}

})